
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work",
      function () {
        return require("private-next-pages/work/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work"])
      });
    }
  